import ropoCapital from "./ropo.js";
import talenom from "./talenom.js";

export default {
  ropoCapital,
  talenom,
};
